module.exports = __webpack_public_path__ + "static/media/done-1.bdd8de3e.png";